import { textSize } from '@hover/blueprint-theme';
import { fromEntries } from '@hover/utilities';

var hoverSelector = ':hover:not([disabled]):not([data-disabled])';
var activeSelector = ':active:not([disabled]):not([data-disabled])';
var disabledSelector = '&[disabled]:not([data-loading]), &[data-disabled]:not([data-loading])';
var focusSelector = ':focus-visible, &:has(input:focus-visible)';

var sizes = /*#__PURE__*/fromEntries( /*#__PURE__*/textSize.map(function (size) {
  return [size, {
    textStyle: "body".concat(size)
  }];
}));

export { activeSelector as a, disabledSelector as d, focusSelector as f, hoverSelector as h, sizes as s };
